import { render } from "./BorderDate.vue?vue&type=template&id=63e258fb&scoped=true"
import script from "./BorderDate.vue?vue&type=script&lang=js"
export * from "./BorderDate.vue?vue&type=script&lang=js"

import "./BorderDate.vue?vue&type=style&index=0&id=63e258fb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63e258fb"

export default script